import { Component, OnInit, AfterViewInit, Inject, ElementRef, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CoursewareService } from 'src/services/CoursewareService';
import { AlertService } from '../_alert';
import { Error } from 'src/model/Error';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { MetaService } from 'src/services/MetaService';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css'],
})
export class ContactUsComponent implements OnInit, AfterViewInit, OnDestroy {
  public sent: boolean = false;

  constructor(private _router: Router, private canonicalService: MetaService, private titleService: Title, private coursewareService: CoursewareService, private alertService: AlertService, @Inject(DOCUMENT) private document, private elementRef: ElementRef) { 
    this.titleService.setTitle("Contact Us - LawShelf Educational Media")
  }

  ngOnDestroy(): void {
    this.canonicalService.removeCanonicalURL();
  }

  ngOnInit() {
    this.canonicalService.createCanonicalURL(this._router.url,"/contactusview/");
  }

  ngAfterViewInit() {
    const s = this.document.createElement('script');
    s.type = 'text/javascript';
    s.src = 'https://www.google.com/recaptcha/api.js';
    const __this = this; //to store the current instance to call 
                         //afterScriptAdded function on onload event of 
                         //script.
    s.onload = function () { 
      __this.afterScriptAdded(); 
    };
    this.elementRef.nativeElement.appendChild(s);
  }

  afterScriptAdded() {
    const params= {
      width: '350px',
      height: '420px',
    };
    if (typeof (window['functionFromExternalScript']) === 'function') {
      window['functionFromExternalScript'](params);
    }
  }

  public doContactUs(form: NgForm)
  {
    this.alertService.clear();
    let myComment = "";
    if (form.value.Comment.length == 0 )
    {
      let theDate = new Date();
      myComment = "" + (theDate.getFullYear() * 100 + theDate.getMonth() + 1);
    }
    this.coursewareService.ContactUs(form.value.Email, form.value.Message, myComment).subscribe(data => {
      if (data == "SUCCESS")
      {
        this.sent = true;
        return;
      }
      let error: Error = data;
      this.alertService.error(error.Message);
    });
  }

}
